import * as React from 'react'
import {loaderImage} from '../../../assets/Assets'

export default class Loader extends React.Component {
    render() {
        return(
            <div className="loader">
                <img src={loaderImage}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Loader.tsx